// ═══════════════════════════════════════════════════════════════════
//  modules/luckperms/api.js
//  Les appels du module LuckPerms, et les trois états d'une case.
// ═══════════════════════════════════════════════════════════════════

import { API_BASE, authHeaders } from "../../socle/api";

async function lire(reponse) {
  const texte = await reponse.text();
  let corps = null;
  try { corps = texte ? JSON.parse(texte) : null; } catch { corps = { error: texte }; }
  if (!reponse.ok) throw new Error((corps && corps.error) || `Erreur ${reponse.status}`);
  return corps;
}

export function luckpermsApi(token) {
  const h = authHeaders(token);
  return {
    etat: () =>
      fetch(`${API_BASE}/api/luckperms/etat`, { headers: h }).then(lire),

    appliquer: (changements, motif) =>
      fetch(`${API_BASE}/api/luckperms/appliquer`, {
        method: "POST", headers: h,
        body: JSON.stringify({ changements, motif }),
      }).then(lire),

    journal: (limite = 300, node = null) =>
      fetch(
        `${API_BASE}/api/luckperms/journal?limite=${limite}` +
        (node ? `&node=${encodeURIComponent(node)}` : ""),
        { headers: h }
      ).then(lire),

    catalogue: (corps) =>
      fetch(`${API_BASE}/api/luckperms/catalogue`, {
        method: "POST", headers: h, body: JSON.stringify(corps),
      }).then(lire),
  };
}

// ─── Les trois états ───────────────────────────────────────────────
//  true   accordée
//  unset  absente — l'héritage joue
//  false  refusée explicitement — l'héritage est coupé
//
//  « unset » et « false » ne sont pas la même chose : le premier dit
//  « ce grade n'a pas cette permission », le second « ce grade ne doit
//  jamais l'avoir ». C'est toute la différence entre un oubli et une
//  décision.
export const VALEURS = ["true", "unset", "false"];
export const suivante = (v) => VALEURS[(VALEURS.indexOf(v) + 1) % 3];
export const symbole = (v) => (v === "true" ? "✓" : v === "false" ? "✕" : "·");
export const libelleValeur = (v) =>
  v === "true" ? "accordée" : v === "false" ? "refusée explicitement" : "absente";

export function commandeDe(node, grade, valeur) {
  return valeur === "unset"
    ? `lp group ${grade} permission unset ${node}`
    : `lp group ${grade} permission set ${node} ${valeur}`;
}
